import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import FloatingContact from '../../../components/feature/FloatingContact';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const ResidentialProjects = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <FloatingContact />

      {/* Hero Section */}
      <section className="pt-24 md:pt-32 pb-12 md:pb-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-20">
          <div className="max-w-4xl">
            <p className="text-mid-gray text-xs uppercase tracking-[0.3em] mb-4 font-sans">
              Hizmetler
            </p>
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-dark-gray leading-tight mb-6">
              Konut Projeleri
            </h1>
            <p className="font-sans text-base md:text-lg text-mid-gray leading-relaxed">
              Modern yaşam alanlarında fonksiyonel çözümler ve estetik mükemmellik
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-12 md:py-16 lg:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-8 lg:px-20">
          <article className="prose prose-lg max-w-none">
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6 md:mb-8">
              Konut projelerinde mimari yaklaşım, yalnızca estetik bir görünüm yaratmakla sınırlı değildir. Her konut projesi, kullanıcıların günlük yaşam pratiklerini, konfor beklentilerini ve mekânsal ihtiyaçlarını derinlemesine anlamayı gerektirir. Bu anlayışla tasarlanan her proje, yaşam kalitesini artıran, zamansız ve işlevsel mekânlar sunar.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Tasarım Felsefesi
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Modern konut tasarımında minimalizm ve fonksiyonellik temel ilkelerdir. Gereksiz detaylardan arındırılmış, sade çizgiler ve açık mekân organizasyonu, kullanıcıya özgürlük hissi verir. Doğal ışığın mekâna girişi, havalandırma ve mekânlar arası akış, tasarım sürecinin merkezinde yer alır.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Her konut projesi, kullanıcının yaşam tarzına özel olarak şekillendirilir. Açık mutfak konseptleri, geniş yaşam alanları, özel çalışma odaları ve dinlenme alanları, modern yaşamın gereksinimlerine yanıt verecek şekilde planlanır. Mekânsal esneklik, gelecekteki ihtiyaç değişimlerine adaptasyonu kolaylaştırır.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Malzeme Seçimi ve Detay
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Konut projelerinde kullanılan malzemeler, estetik görünümün yanı sıra dayanıklılık ve sürdürülebilirlik açısından da titizlikle seçilir. Doğal ahşap, taş, beton ve cam gibi malzemeler, mekâna sıcaklık ve karakter kazandırırken, uzun ömürlü kullanım sağlar.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              İç mekân tasarımında renk paleti, nötr ve sakin tonlarla oluşturulur. Beyaz, bej, gri ve toprak tonları, mekâna ferahlık ve huzur katar. Mobilya seçiminde sadelik ve konfor ön plandadır. Her detay, genel tasarım diliyle uyumlu olacak şekilde planlanır.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Işık ve Mekân İlişkisi
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Doğal ışık, konut tasarımının en önemli unsurlarından biridir. Geniş pencereler, cam cepheler ve ışık kuyuları, mekânın gün boyunca farklı atmosferler kazanmasını sağlar. Işığın mekâna girişi, kullanıcının ruh halini ve enerji seviyesini doğrudan etkiler.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Yapay aydınlatma tasarımı, doğal ışığı tamamlayıcı niteliktedir. Gömme aydınlatmalar, spot ışıklar ve dekoratif armatürler, mekânın farklı işlevsel alanlarını vurgular. Aydınlatma senaryoları, günün farklı saatlerinde ve farklı kullanım durumlarında esneklik sağlar.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Dış Mekân Entegrasyonu
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Modern konut projelerinde iç ve dış mekân arasındaki sınırlar bulanıklaşır. Teraslar, balkonlar ve bahçeler, yaşam alanının doğal uzantısı olarak tasarlanır. Geniş cam kapılar ve sürgülü sistemler, mekânlar arası geçişi kolaylaştırır.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Peyzaj tasarımı, mimari dille uyumlu olacak şekilde planlanır. Yerel bitki türleri, su öğeleri ve oturma alanları, dış mekânı yaşanabilir kılar. Sürdürülebilir peyzaj uygulamaları, bakım maliyetlerini azaltırken çevresel etkileri minimize eder.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Sürdürülebilirlik ve Enerji Verimliliği
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Çağdaş konut tasarımında enerji verimliliği ve sürdürülebilirlik vazgeçilmez unsurlardır. Yalıtım sistemleri, enerji verimli pencereler ve akıllı ısıtma-soğutma çözümleri, enerji tüketimini minimize eder. Güneş enerjisi panelleri ve yağmur suyu toplama sistemleri, doğal kaynakların verimli kullanımını sağlar.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Yapı malzemelerinin seçiminde çevresel etki göz önünde bulundurulur. Geri dönüştürülebilir malzemeler, düşük karbon ayak izine sahip ürünler ve yerel kaynaklardan temin edilen malzemeler tercih edilir. Bu yaklaşım, hem çevresel sorumluluğu yerine getirir hem de uzun vadede ekonomik avantaj sağlar.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Akıllı Ev Teknolojileri
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Modern konut projelerinde akıllı ev sistemleri, konfor ve güvenliği artırır. Aydınlatma, ısıtma, güvenlik ve eğlence sistemleri, merkezi kontrol panelleri veya mobil uygulamalar üzerinden yönetilebilir. Otomasyon sistemleri, kullanıcının alışkanlıklarını öğrenerek enerji tasarrufu sağlar.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Ses ve görüntü sistemleri, mekânın estetik bütünlüğünü bozmayacak şekilde entegre edilir. Gömme hoparlörler, gizli kablolama ve minimal donanım kullanımı, teknolojinin görünmez kalmasını sağlar. Bu yaklaşım, modern yaşamın gereksinimlerini karşılarken mimari saflığı korur.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Proje Süreci
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Her konut projesi, detaylı bir analiz ve planlama süreciyle başlar. Kullanıcı ihtiyaçları, arsa özellikleri, iklim koşulları ve yasal düzenlemeler kapsamlı olarak değerlendirilir. Konsept tasarım aşamasında, farklı alternatifler üretilir ve kullanıcıyla birlikte en uygun çözüm belirlenir.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Uygulama projesi aşamasında, tüm teknik detaylar netleştirilir. Statik hesaplamalar, mekanik ve elektrik projeleri, mimari projelerle koordineli olarak geliştirilir. Şantiye süreci boyunca düzenli denetimler yapılır, kalite standartlarının korunması sağlanır.
            </p>

            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mt-12">
              Konut projeleri, yalnızca barınma ihtiyacını karşılamakla kalmaz; kullanıcıların yaşam kalitesini artıran, estetik değeri yüksek ve zamansız mekânlar yaratır. Her proje, mimari disiplinin tüm unsurlarını bir araya getirerek, kullanıcıya özgü, anlamlı yaşam alanları sunar.
            </p>
          </article>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-20 bg-cream">
        <div className="max-w-4xl mx-auto px-6 md:px-8 lg:px-20 text-center">
          <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mb-6">
            Konut Projeniz İçin Görüşelim
          </h2>
          <p className="font-sans text-sm md:text-base text-mid-gray mb-8 max-w-2xl mx-auto">
            Hayalinizdeki yaşam alanını birlikte tasarlayalım
          </p>
          <Link
            to="/iletisim"
            className="inline-block border border-dark-gray text-dark-gray px-8 py-3 text-sm tracking-wide hover:bg-dark-gray hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            İletişime Geçin
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ResidentialProjects;
